import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import SummaryField         from '../SummaryField';
import { browserHistory }   from 'react-router';

let FaEdit = require('react-icons/lib/fa/edit');
let FaCheck = require('react-icons/lib/fa/check-circle');
let FaCross = require('react-icons/lib/fa/times-circle');
let FaClock = require('react-icons/lib/fa/clock-o');
let Quote =  require('../Managers/Quote');
let val;

class SummaryWidgetEntity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: null,
            showAddressModal: false,
            showAddressHistoryWarningModal: false,
            fieldValue: null,
        };
    }

    componentWillMount() {
        val = Quote.getByPath(this.props.localStorageChunk + '.' + this.props.localStorageKey);
        if (this.props.fieldType === 'select') {
            this.parseIntValue(this.props.options, val);
        }

        if (!window.uorn(val)) {
            this.setState({
                startValue: this.props.fieldType === 'address' ? val : val.toString(),
                endValue: this.props.fieldType === 'address' ? val : val.toString(),
            }, () => {
                this.updateFieldValueStateFromStartAndEndValueState();
            });
        }
    }

    /**
     * Takes an array of objects. Matches an object against a provided ID and
     * parses the object's text value.
     *
     * @param arr
     * @param v
     */
    parseIntValue(arr, v) {
        let newVal = arr.filter(function(obj) {
            return obj.option_value == parseInt(v);
        });

        val = newVal[0].option_text;
    }

    updateFieldValueStateFromStartAndEndValueState() {
        let fieldValue = null;
        // once the start value and end value are updated, update the field value
        if (this.props.fieldType === 'address') {
            fieldValue =
                (this.state.endValue.flat ? this.state.endValue.flat + ', ' : '') +
                (this.state.endValue.houseNumber ? this.state.endValue.houseNumber + ', ' : '') +
                (this.state.endValue.houseName ? this.state.endValue.houseName + ', ' : '') +
                (this.state.endValue.street ? this.state.endValue.street + ', ' : '') +
                (this.state.endValue.town ? this.state.endValue.town + ', ' : '') +
                (this.state.endValue.postcode ? this.state.endValue.postcode : '');
        } else {
            fieldValue = (this.props.labelPrefix ? this.props.labelPrefix : '') + this.state.endValue + (this.props.labelAffix ? ' ' + this.props.labelAffix : '');
        }

        this.setState({ fieldValue });
    }

    /**
     * Toggle the state of the edit field
     */
    toggleEdit() {
        val = Quote.getByPath(this.props.localStorageChunk + '.' + this.props.localStorageKey);
        if (this.props.minimumConstraint && this.state.isEditing === true) {
            if (document.getElementById(this.props.fieldName).value < this.props.minimumConstraint) {
                val = this.props.minimumConstraint;
            }
            this.setState({
                isEditing: false,
                endValue: val,
                startValue: val,
            }, () => {
                Quote.set(this.props.localStorageKey, val, this.props.localStorageChunk);
                this.updateFieldValueStateFromStartAndEndValueState();
            });
        } else {
            if (this.props.fieldType === 'select') {
                this.parseIntValue(this.props.options, val);
            }

            if (this.props.fieldType === 'address') {
                this.setState({
                    showAddressModal: true,
                    endValue: val,
                }, () => {
                    this.updateFieldValueStateFromStartAndEndValueState();
                });
            } else {
                this.setState({
                    isEditing: this.state.isEditing === true ? false : true,
                    endValue: val.toString(),
                }, () => {
                    this.updateFieldValueStateFromStartAndEndValueState();
                });
            }
        }

        // get addresses
        let addresses;
        if (Quote.getByPath('BaseIndividualApplication.referenceNumber')) {
            addresses = Quote.getLocalStorageAddresses();
            let totalMonths = 0;
            addresses.map((a, i) => {
                totalMonths += parseInt(Quote.get('durationMonths', 'BaseIndividualApplication.addressHistories.' + i));
            });

            // We have less than 36 months of address history now, so warn the user
            if (totalMonths < 36) {
                this.setState({ showAddressHistoryWarningModal: true });
            }
        }
    }

    /**
     * If the user cancels the edit, reset to the start value
     */
    cancelEdit() {
        Quote.set(this.props.localStorageKey, this.state.startValue, this.props.localStorageChunk);
        this.setState({ isEditing: false });
    }

    updateCompoundValues(e) {
        // if cancelable, update the real values and delete the canceable
        if (this.props.cancelable) {
            let realPath = this.props.localStorageChunk + '.' + this.props.localStorageKey;
            let tempPath = this.props.localStorageChunk + '.' + this.props.localStorageKey + 'temp';
            let tempValue = Quote.getByPath(tempPath);
            Quote.setByPath(realPath, tempValue);
        }

        // then close our modals, which takes care of deleting the temp
        this.closeModals(e);

        // pull the new value out and use that set state, and then call the field updater
        val = Quote.getByPath(this.props.localStorageChunk + '.' + this.props.localStorageKey);
        this.setState({
            startValue: val,
            endValue: val,
        }, () => {
            this.updateFieldValueStateFromStartAndEndValueState();
        });
    }

    /**
     * Close all active modals
     *
     * @param e
     */
    closeModals(e) {
        // if cancelable, delete the canceable
        e.preventDefault();
        this.setState({ showAddressModal: false });
        if (this.props.cancelable) {
            Quote.deleteByPath(this.props.localStorageChunk + '.' + this.props.localStorageKey + 'temp');
        }
    }

    /**
     * Take the user back to the 'your details' step - fires on the instance of
     * editing address history to a state of less than 36 months total.
     *
     * @param e
     */
    goBackTotDetails(e) {
        e.preventDefault();
        this.closeModals(e);
        browserHistory.push('/application/your-details');
    }

    renderStatusIcon(status) {
        switch(status) {
            case 'success':
                return(<FaCheck className="column icon no-edit success-colour" />);
            case 'fail':
                return(<FaCross className="column icon no-edit danger-colour" />);
            case 'pending':
                return(<FaClock className="column icon no-edit" />);
        }
    }

    render() {
        return(
            <div>
                {this.state.isEditing ?
                    <div>
                        <div className="row-label">
                            <strong>{this.props.label}: </strong>
                        </div>
                        <div className="row-edit">
                            <div className="column">
                                {this.props.fieldType === 'text' ?
                                    <SummaryField
                                        fieldName={this.props.fieldName}
                                        type={this.props.fieldType}
                                        question={this.props.label}
                                        loadValues={true}
                                        defaultValue={this.state.startValue}
                                        source={this.props.localStorageChunk}
                                        storageKey={this.props.localStorageKey}
                                        maxLength={24}
                                    />
                                : null}

                                {this.props.fieldType === 'money' || this.props.fieldType === 'number' ?
                                    <SummaryField
                                        fieldName={this.props.fieldName}
                                        type={this.props.fieldType}
                                        question={this.props.label}
                                        loadValues={true}
                                        defaultValue={this.state.startValue}
                                        source={this.props.localStorageChunk}
                                        storageKey={this.props.localStorageKey}
                                        callbackFunction={this.props.callbackFunction ? this.props.callbackFunction : null}
                                    />
                                : null}

                                {this.props.fieldType === 'email' ?
                                    <SummaryField
                                        fieldName={this.props.fieldName}
                                        type={this.props.fieldType}
                                        question={this.props.label}
                                        loadValues={true}
                                        defaultValue={this.state.startValue}
                                        source={this.props.localStorageChunk}
                                        storageKey={this.props.localStorageKey}
                                    />
                                : null}

                                {this.props.fieldType === 'date' ?
                                    <SummaryField
                                        fieldName={this.props.fieldName}
                                        type={this.props.fieldType}
                                        subType={this.props.subType}
                                        question={this.props.label}
                                        loadValues={true}
                                        defaultValue={this.state.startValue}
                                        source={this.props.localStorageChunk}
                                        storageKey={this.props.localStorageKey}
                                    />
                                : null}

                                {this.props.fieldType === 'select' ?
                                    <SummaryField
                                        fieldName={this.props.fieldName}
                                        type={this.props.fieldType}
                                        question={this.props.label}
                                        loadValues={true}
                                        defaultValue={this.state.startValue}
                                        source={this.props.localStorageChunk}
                                        storageKey={this.props.localStorageKey}
                                        isInt={this.props.isInt}
                                        options={this.props.options}
                                    />
                                : null}
                            </div>
                            <div className="column icon" onClick={this.cancelEdit.bind(this)}>
                                <FaCross />
                            </div>
                            <div className="column icon" onClick={this.toggleEdit.bind(this)}>
                                <FaCheck />
                            </div>
                        </div>
                    </div>
                :
                    <div className="row-value">
                        <div className="column row-label">
                            <strong>{this.props.label}:</strong>
                        </div>
                        <div className="column">
                            {this.props.hideValue === false ?
                                this.state.fieldValue
                            : null}
                        </div>

                        {this.props.isEditable === true ?
                            <FaEdit className="column icon" onClick={this.toggleEdit.bind(this)} />
                        : null}

                        {this.props.statusType ?
                            this.renderStatusIcon(this.props.statusType)
                        : null}
                    </div>
                }

                {this.props.fieldType === 'address' ?
                    <div className={this.state.showAddressModal === true ? 'modal-container modal-active' : 'modal-container'}>
                        <div className="modal medium-width has-footer">
                            <div className="modal-header">
                                Editing {this.props.label}
                                <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                    <FaCross className="pointer" />
                                </div>
                            </div>
                            <div className="modal-body">
                                <SummaryField
                                    fieldName={this.props.fieldName}
                                    type={this.props.fieldType}
                                    question={this.props.label + ' postcode'}
                                    loadValues={true}
                                    source={this.props.cancelable ? this.props.localStorageChunk + '.' + this.props.localStorageKey + 'temp' : this.props.localStorageChunk + '.' + this.props.localStorageKey}
                                    storageKey={this.props.cancelable ? this.props.localStorageKey : this.props.localStorageKey + 'temp'}
                                    addressOptions={{
                                        canHaveManualEntry: this.props.addressOptions.canHaveManualEntry,
                                        canBeForeign: this.props.addressOptions.canBeForeign,
                                        pafLookup: this.props.addressOptions.pafLookup,
                                    }}
                                    isInAModal={true}
                                />
                            </div>
                            <div className="modal-footer">
                                <a
                                    id="saveAddressChanges"
                                    className="btn btn-success pull-left"
                                    onClick={this.updateCompoundValues.bind(this)}
                                >Save</a>
                                <a
                                    id="cancelAddressChanges"
                                    className="btn btn-default pull-right"
                                    onClick={this.closeModals.bind(this)}
                                >Cancel</a>
                                <div className="clearfix" />
                            </div>
                        </div>
                    </div>
                : null}

                <div className={this.state.showAddressHistoryWarningModal === true ? 'modal-container modal-active' : 'modal-container'}>
                    <div className="modal medium-width has-footer">
                        <div className="modal-header">
                            Address History Error
                            <div className="close-cross" onClick={this.goBackTotDetails.bind(this)}>
                                <FaCross className="pointer" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <p>You need to enter 3 years worth of addresses or last 3 addresses</p>
                        </div>
                        <div className="modal-footer">
                            <a
                                id="acceptAddressHistoryError"
                                className="btn btn-success"
                                onClick={this.goBackTotDetails.bind(this)}
                            >OK</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

SummaryWidgetEntity.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    localStorageChunk:  PropTypes.string.isRequired,
    localStorageKey:    PropTypes.string.isRequired,
    fieldType:          PropTypes.oneOf(['text', 'number', 'money', 'email', 'address', 'select', 'date', 'static']).isRequired,
    subType:            PropTypes.string,
    label:              PropTypes.string.isRequired,
    labelAffix:         PropTypes.string,
    labelPrefix:        PropTypes.string,
    minimumConstraint:  PropTypes.number,
    dataValidation:     PropTypes.string,
    callbackFunction:   PropTypes.func,
    inputMask:          PropTypes.string,
    isInt:              PropTypes.bool,
    isEditable:         PropTypes.bool,
    hideValue:          PropTypes.bool,
    statusType:         PropTypes.oneOf(['success', 'fail', 'pending']),
    cancelable:         PropTypes.bool,
    options:            PropTypes.arrayOf(
        PropTypes.object
    ),
    addressOptions:     PropTypes.shape({
        pafLookup:              PropTypes.bool.isRequired,
        canHaveManualEntry:     PropTypes.bool,
        canBeForeign:           PropTypes.bool,
    }),
};

SummaryWidgetEntity.defaultProps = {
    localStorageChunk: 'BaseIndividualApplication',
    fieldType: 'text',
    isEditable: true,
    hideValue: false,
};

export default SummaryWidgetEntity;


// WEBPACK FOOTER //
// ./src/components/Fragments/SummaryWidgetEntity.js